/**
 * Created by wangjianwen on 2017/10/16.
 */
import * as func from '../function';
export  default{
    setHeaderState(states, headerState){
        states.headerState = headerState;
        func.func.set('headerState',headerState);
    },
    setToken(states, token){
        states.token = token;
        func.func.set('token',token);
    },
    setJwtToken(states, jwtToken){
        states.jwtToken = jwtToken;
        func.func.set('jwtToken',jwtToken);
    },
    setPageInfo(states, pageInfo){
        states.pageInfo = pageInfo;
        func.func.set('pageInfo',pageInfo);
    },
    setFooterInfo(states, footerInfo){
        states.footerInfo = footerInfo;
        func.func.set('footerInfo',footerInfo);
    },
    setUserType(states, userType){
        states.userType = userType;
        func.func.set('userType',userType);
    },
    setCurrentUser(states, userInfo){
        states.currentUser = userInfo;
        func.func.set('currentUser',userInfo);
    },
    setCertType(states, certType){
        states.certType = certType;
        func.func.set('certType',certType);
    },
    setProjectToken(states, projectToken){
        states.projectToken = projectToken;
        func.func.set('projectToken',projectToken);
    },
    removeCurrentUser(states){
        states.currentUser = null;
        states.userType = null;
        states.token = null;
        func.func.clear('currentUser');
        func.func.clear('userType');
        func.func.clear('token');
    }
}